export const newsData: Array<{
  id: string;
  title: string;
  category: string;
  date: string;
  readTime: string;
  excerpt: string;
  content: string;
  image: string;
  videoUrl: string;
  author: string;
  featured: boolean;
}> = [];
